module.exports = __webpack_public_path__ + "img/AT0000000537678.bf218c4b.png";